const httpGameByCustomerIdView = ({ httpPost }) => async ({ customerId, signal }) => await httpPost({
    endpoint: "/view-game-by-customer-id",
    body: {
        customerId,
    },
    signal,
    result: {
        error: null,
        success: (response) => response,
    },
});
export { httpGameByCustomerIdView };
